// QA 服務請求（帶 Bearer Token），baseURL 指向 QA 服務。
// 本機開發走 webpack devServer proxy，故 baseURL 為空字串。
import axios from 'axios';
import { attachAuthInterceptor, attachResponseInterceptor } from './interceptors';

const qaRequest = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL : '',
  withCredentials: true,
  xsrfHeaderName: 'xsrf-token',
  xsrfCookieName: 'xsrf-token',
});

attachAuthInterceptor(qaRequest);
attachResponseInterceptor(qaRequest);

export default qaRequest;
